// extracted by mini-css-extract-plugin
export default {"modal":"DU-z","error":"EU-z","disabled":"FU-z","fields":"GU-z","errorMsg":"HU-z","footer":"IU-z","formContentWrapper":"JU-z","productImage":"KU-z","overlay":"LU-z"};